package br.com.htms.inspeccaocampo.platform

data class GpsFix(
    val latitude: Double,
    val longitude: Double,
    val textoLocal: String
)

data class CapturedPhoto(
    val path: String,
    val latitude: Double? = null,
    val longitude: Double? = null
)

expect object PlatformServices {
    val hasCamera: Boolean
    val hasGps: Boolean
    fun openUrl(url: String)
    suspend fun captureGps(): GpsFix?
    /** Abre a câmera; retorna caminho do arquivo JPEG/PNG salvo. */
    suspend fun capturePhoto(): CapturedPhoto?
    /** Seleciona imagem da galeria (banner). */
    suspend fun pickImage(): CapturedPhoto?
    /**
     * Converte traços da assinatura em PNG Base64 (sem prefixo data:).
     * strokes: lista de polilinhas; cada ponto é (x, y) em pixels.
     */
    fun encodeSignaturePngBase64(
        strokes: List<List<Pair<Float, Float>>>,
        width: Int,
        height: Int
    ): String?

    fun decodeBase64(base64: String): ByteArray?
    fun encodeBase64(bytes: ByteArray): String
    /**
     * Lê bytes da imagem. Em Web, se [path] for URL http(s) ou `r2:...`, busca no Worker R2
     * (com cache local). Em Android/iOS, caminho de arquivo local.
     */
    suspend fun loadImageBytes(path: String): ByteArray?
    /**
     * Assets empacotados do app (ex.: logo/banner do PDF na web).
     * Retorna null se não existir nesta plataforma.
     */
    suspend fun loadBundledAsset(fileName: String): ByteArray?
    /**
     * Após carimbo: na Web envia ao R2 e devolve URL (fonte durável ~30 dias);
     * em nativo devolve o mesmo [localPath].
     */
    suspend fun publishPhoto(localPath: String): String
    suspend fun saveBannerImage(bytes: ByteArray): String?
    /**
     * Web: embute JPEG no JSON da inspeção (PDF não depende só do IDB por path).
     * Android/iOS: false (arquivo local basta).
     */
    fun shouldEmbedPhotoBytesInForm(): Boolean
}

fun formatGpsCoordenadas(lat: Double, lng: Double): String {
    fun fmt(v: Double): String {
        val abs = kotlin.math.abs(v)
        val s = abs.toString()
        val dot = s.indexOf('.')
        return if (dot < 0) s else s.take(dot + 7).trimEnd('0').trimEnd('.')
    }
    val latTxt = "${fmt(lat)}${if (lat < 0) "S" else "N"}"
    val lngTxt = "${fmt(lng)}${if (lng < 0) "W" else "E"}"
    return "$latTxt, $lngTxt"
}
